export default __webpack_public_path__ + "static/media/objects-sensing-extraversion.556d2a82.png";